var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:(_vm.title),expression:"title",modifiers:{"hover":true}}],staticClass:"border-gray-light",attrs:{"variant":"light","disabled":_vm.disabled || _vm.isBusy},on:{"click":_vm.createProtocol}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'file-alt']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }